export default (theme) => ({
    iconLink: {
        color: theme.palette.gray.main,
    },
});
